// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".poster[data-v-2587c567] {\n  background-image: linear-gradient(to right, #7a0505, #b92405);\n}\n.poster .box[data-v-2587c567] {\n  min-height: 100vh;\n}\n.poster .box img[data-v-2587c567] {\n  width: 100%;\n  height: 20.8rem;\n}\n.poster .btn[data-v-2587c567] {\n  width: 8.8rem;\n  height: 1.17333rem;\n  position: fixed;\n  bottom: 1.41333rem;\n  left: 50%;\n  transform: translateX(-50%);\n}", ""]);
// Exports
module.exports = exports;
